import { useQuery } from "react-query";
import { fetchAPIUserOrdersFinished } from "../requests/UserOrders";

export function useQueryUserOrdersFinished(user_id: number) {
    const onError = () => {};
    return useQuery(
        "apiUserOrdersFinished",
        async () => await fetchAPIUserOrdersFinished(user_id),
        {
            onError,

        }
    );
}
